module.exports = __webpack_public_path__ + "img/post_img_11-700x441.d2aab60a.jpg";